import React, { useContext, useEffect } from 'react'
import EditCtrl from '../cmp/EditCtrl.js'
import icon from '../icons.svg'

import { dataContext, localestr, isValidDate, typeToText,strPeriod, exportToExcel } from '../utils.js'

function RepPnL({ data = undefined, actions }) {
  let wndData = ''
  let content = ''
  if (data) wndData = data.wndData
  else wndData = actions.getWndData()
  const setWndData = actions.setWndData
  const context = useContext(dataContext)
  const loaddat=context.loaddata
  const getSettings = context.getSettings
  const setSettings = context.setSettings
  const usersettings = getSettings()
  const msg = context.msg
  const inputRange = context.inputRange
  const OpenTabObject = context.OpenTabObject
  const setPosition = context.setPosition
  const position = context.getPosition('RepPnL')
console.log(data)
  let from = new Date()
  from.setDate(1)
  from.setHours(0, 0, 0, 0)
  let to = new Date()
  to.setHours(23, 59, 59, 999)

  let to2 = new Date(from-1)
  //to2.setDate(-1)
  //to2.setHours(23, 59, 59, 999)
  let from2 = new Date(to2)
  from2.setDate(1)
  from2.setHours(0, 0, 0, 0)

  if (usersettings) {
    if (usersettings.repPnL) {
      if (usersettings.repPnL.from) from = new Date(usersettings.repPnL.from)
      if (usersettings.repPnL.to) to = new Date(usersettings.repPnL.to)
      if (usersettings.repPnL.from2) from2 = new Date(usersettings.repPnL.from2)
      if (usersettings.repPnL.to2) to2 = new Date(usersettings.repPnL.to2)
    }
  }
  if (wndData.from) from = wndData.from
  if (wndData.to) to = wndData.to
  if (wndData.from2) from2 = wndData.from2
  if (wndData.to2) to2 = wndData.to2

  function range(frm, to_) {
    //let showRange=!wndData.showRange
    let froml = from
    let tol = to
    if (isValidDate(frm)) froml = frm
    if (isValidDate(to_)) tol = to_
    if (froml > tol) {
      msg(localestr('Не правильний діапазон дат'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
      return
    }
    setWndData({ ...wndData, from: froml, to: tol })
    setSettings({ repPnL: { from: froml, to: tol, from2, to2 } })
  }

  function range2(frm, to_) {
    //let showRange=!wndData.showRange
    let froml = from2
    let tol = to2
    if (isValidDate(frm)) froml = frm
    if (isValidDate(to_)) tol = to_
    if (froml > tol) {
      msg(localestr('Не правильний діапазон дат'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
      return
    }
    setWndData({ ...wndData, from2: froml, to2: tol })
    setSettings({ repPnL: { from, to, from2: froml, to2: tol } })
  }

  function set_department(d){
      setWndData({...wndData, department: d})
  }

  function loadData(d) {
    setPosition('RepPnL', 0)
    if (d) {
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      //Формуємо таблицю з даними для виводу {стаття, сума1, сума2, рівень, чи відкрита, документ}
      let ttl1=0
      let ttl2=0
      let level1=null
      let idx1=-1
      let idx2=-1
      let level2=null
      let data=[]
      for(let i=0;i<d.data.length;i++){
        if(d.data[i].acc!==level1) {
          if((d.data[i].acc==='719'||d.data[i].acc==='920')&&(level1==='701'||level1==='901')) {
            data.push({name:'Валовий прибуток (збиток) від реалізації продукції (товарів, робіт, послуг)', am1:ttl1, am2:ttl2, level:0,open:false})
          }
          level1=d.data[i].acc
          level2=null
          idx1=data.length
          let name=''
          if(level1==='701') name='Чистий  дохід від реалізації продукції (товарів, робіт, послуг)'
          else if(level1==='901'||level1==='902') name='Собівартість реалізованої продукції (товарів, робіт, послуг)'
          else if(level1==='719') name='Інші операційні доходи'
          else if(level1==='920') name='Інші операційні витрати'
          else name=level1
          data.push({name:name, am1:0, am2:0, level:0,open:false})
        }
        if(d.data[i].art_id!==level2) {
          level2=d.data[i].art_id
          idx2=data.length
          data.push({name:d.data[i].art_n, am1:0, am2:0, level:1,open:false,key:level1+level2,acc:level1})
        }
        ttl1+=d.data[i].am||0
        ttl2+=d.data[i].am2||0
        if(idx1>-1) data[idx1].am1+=d.data[i].am
        if(idx1>-1) data[idx1].am2+=d.data[i].am2
        if(idx2>-1) data[idx2].am1+=d.data[i].am
        if(idx2>-1) data[idx2].am2+=d.data[i].am2
        if(d.data[i].doc_id) {
          const doc=typeToText(d.data[i].doc_t) + ' №' + d.data[i].doc_id + ' (' + new Date(d.data[i].doc_d).toLocaleString() + ')'
          data.push({name:doc, am1:d.data[i].am, am2:d.data[i].am2, level:2,key:level1+level2,obj:{type: d.data[i].doc_t, id: d.data[i].doc_id}})
        }
      }
      if(ttl1||ttl2) data.push({name:'Чистий прибуток (збиток)', am1:ttl1, am2:ttl2, level:0,open:false})

      setWndData({ ...wndData, content: { headcol1:strPeriod(new Date(d.from), new Date(d.to)), headcol2:strPeriod(new Date(d.from2), new Date(d.to2)), department:d.department, data, caption: 'Фінансовий звіт про прибутки та збитки (P&L)' } })

    } else {
      let froml = from.toISOString().substring(0, 19) + 'Z'
      let tol = to.toISOString().substring(0, 19) + 'Z'
      let froml2 = from2.toISOString().substring(0, 19) + 'Z'
      let tol2 = to2.toISOString().substring(0, 19) + 'Z'
      let tz = to.getTimezoneOffset()
      if (tz < 0) tz = '%2B0' + (tz / -60) + ':00'
      else tz = '-0' + (tz / 60) + ':00'
      let department = wndData.department?.id ? {id: wndData.department.id, name: wndData.department.name} : null
      loaddat('action=repPnL&data=' + encodeURIComponent(JSON.stringify({ from: froml, to: tol,from2: froml2, to2: tol2, tz, department })),null, (dt) => { loadData(dt) })
    }
  }

  function specification(obj) {
    if (!obj) return
    //console.log(obj)
    OpenTabObject(obj.type, obj.id)
  }

  function open_close(idx) {
    const data = wndData.content.data
    data[idx].open = !data[idx].open
    setWndData({ ...wndData, content: { ...wndData.content, data: data, caption: 'Фінансовий звіт про прибутки та збитки (P&L)' } })
  }

  if (wndData.content) {
    let filters = null
    if (wndData.content.department) filters=<p>{localestr('Підрозділ')}: {wndData.content.department.name}</p>
    filters = <div className='rep_filters'>{filters}</div>
    const items =[]
    let key_open=''
    wndData.content.data.forEach((el, idx) => {
      if(el.level===1&&el.open) key_open=el.key
      if(el.level!==2||el.key===key_open) {
        if(el.obj) items.push(
          <tr tabIndex='0' style={{fontStyle:'italic',fontSize:'smaller'}} key={idx} onDoubleClick={() => specification(el.obj)}><td style={{cursor: 'pointer'}} className={'rep_grp' + el.level}>{el.name}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.am1.toFixed(2)}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.am2.toFixed(2)}</td></tr>
        )
        else if(el.level===0) items.push(
          <tr tabIndex='0' key={idx} style={{fontWeight: '600'}}><td className={'rep_grp' + el.level}>{el.name}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.am1.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.am2.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</td></tr>
        )
        else if(el.level===1&&(el.acc==='701'||el.acc==='901')) items.push(
          <tr tabIndex='0' key={idx}><td className={'rep_grp' + el.level}>{el.name}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.am1.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.am2.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</td></tr>
        )
        else items.push(
          <tr tabIndex='0' key={idx} style={{cursor: 'pointer'}} onClick={()=>open_close(idx)}><td className={'rep_grp' + el.level}>{el.name}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.am1.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.am2.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</td></tr>
        )
      }
    })
    /* wndData.content.data.map((el, idx) => {
      if (el.obj) return <tr tabIndex='0' key={idx}><td style={{ cursor: 'pointer' }} className={'rep_grp' + el.level} onDoubleClick={() => specification(el.obj)}>{el.name}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.qtt}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.am.toFixed(2)}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.gst}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.gst===0?'':(el.am/el.gst).toFixed(2)}</td><td className={'rep_grp' + el.level + ' rep_number'}>{(el.tip||0).toFixed(2)}</td></tr>
      else return <tr tabIndex='0' key={idx}><td className={'rep_grp' + el.level}>{el.name}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.qtt}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.am.toFixed(2)}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.gst}</td><td className={'rep_grp' + el.level + ' rep_number'}>{el.gst===0?'':(el.am/el.gst).toFixed(2)}</td><td className={'rep_grp' + el.level + ' rep_number'}>{(el.tip||0).toFixed(2)}</td></tr>
    })*/
    content = <><h3 className='rep_caption'>Фінансовий звіт про прибутки та збитки (P&L)</h3>{filters}
      <table className='rep_table'>
        <thead><tr><th>{localestr('Стаття')}</th><th>{wndData.content.headcol1}</th><th>{wndData.content.headcol2}</th></tr></thead>
        <tbody>{items}</tbody>
      </table>
    </>
  }

  //const showRange = wndData.showRange ? <RangeForm from={from} to={to} setRng={range}/> : ''  //+
  const setPos = target => {
    if (!target) return
    //if(!position) return
    target.scrollTop = position
  }

  let btn2 = null
  if (content) {
    btn2 = <div className='no-print' style={{ position: 'absolute', top: '5px', right: '5px', display: 'flex', gap: '5px' }}>
      <div onClick={e => window.print()} style={{ cursor: 'pointer', }}>
        <img style={{ width: '24px', height: '24px' }} src={icon + '#b503'} alt='' />
      </div>
      <div style={{ cursor: 'pointer', }} onClick={() => exportToExcel(wndData)}>
        <img style={{ width: '24px', height: '24px' }} src={icon + '#xlsx'} alt='' />
      </div>
    </div>
  }

  useEffect(() => {
    if (wndData && wndData.run) setTimeout(loadData, 200)
    // eslint-disable-next-line 
  }, [])

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row' }}>
      <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div className='toolBar no-print'>
          <div tabIndex='0' onClick={() => { loadData() }} onKeyUp={(e) => { if (e.key === 'Enter') loadData() }}
            style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
            <img style={{ width: '12px', height: '24px', padding: '2px', verticalAlign: 'middle' }} src={icon + '#run'} alt={localestr('Вивести')} />&nbsp;
            {localestr('Вивести')}
          </div>
          <div style={{lineHeight: '30px',padding: '0px 4px 0px 10px'}}>{localestr('Період звіту')}</div>
          <div tabIndex='0' onClick={() => { inputRange(from, to, range) }} onKeyUp={(e) => { if (e.key === 'Enter') range() }}
            style={{ textAlign: 'center', lineHeight: '30px', height: '30px', width: '192px', padding: '0px 20px 0 2px', userSelect: 'none', cursor: 'pointer', color: '#FFF', background: 'url(' + icon + '#btn185v) no-repeat', backgroundSize: '192px 30px', boxSizing: 'border-box', position: 'relative', wordBreak: 'break-all' }}>
            {strPeriod(from, to)}
            <img style={{ width: '24px', height: '24px', position: 'absolute', top: '5px', right: '4px' }} src={icon + '#cal_w'} alt={localestr('Інтервал дат')} />
          </div>
          <div style={{lineHeight: '30px',padding: '0px 4px 0px 10px'}}>{localestr('Порівняльний період')}</div>
          <div tabIndex='0' onClick={() => { inputRange(from2, to2, range2) }} onKeyUp={(e) => { if (e.key === 'Enter') range2() }}
            style={{ textAlign: 'center', lineHeight: '30px', height: '30px', width: '192px', padding: '0px 20px 0 2px', userSelect: 'none', cursor: 'pointer', color: '#FFF', background: 'url(' + icon + '#btn185v) no-repeat', backgroundSize: '192px 30px', boxSizing: 'border-box', position: 'relative', wordBreak: 'break-all' }}>
            {strPeriod(from2, to2)}
            <img style={{ width: '24px', height: '24px', position: 'absolute', top: '5px', right: '4px' }} src={icon + '#cal_w'} alt={localestr('Інтервал дат')} />
          </div>
          <div style={{padding: '10px'}}></div>
          <EditCtrl Capt={localestr('По вибраному підрозділу')} Value={wndData.department} typeVal={'catDepartments'} setVal={set_department} width1='190' width2='110' />
          <div style={{flexGrow:'10'}}></div>
        </div>
        <div className='reportContent' style={{ position: 'relative' }} ref={el => { setPos(el) }} onScroll={e => setPosition('RepPnL', e.target.scrollTop)}>{content}{btn2}</div>
      </div>
      {/*showRange*/}
    </div>
  )

}


export default RepPnL